import type { BillingNumberValidationIssue } from '@billing/validation';
import type { useTranslation } from '@refinedev/core';
import type { Payor } from 'interfaces';

type Translate = ReturnType<typeof useTranslation>['translate'];

export const getBillingNumberValidationError = (
  payor: Payor,
  issue: BillingNumberValidationIssue | null,
  translate: Translate
): string | undefined => {
  if (!issue) return undefined;

  const hasExactLength =
    payor.billingNumberMinLength != null &&
    payor.billingNumberMinLength === payor.billingNumberMaxLength;

  if (
    hasExactLength &&
    (issue.code === 'minLength' || issue.code === 'maxLength')
  ) {
    return translate(
      'pages:providers.billingNumbers.errors.exactLength',
      { length: issue.length },
      'Billing number must be exactly {{length}} characters long.'
    );
  }

  switch (issue.code) {
    case 'minLength':
      return translate(
        'pages:providers.billingNumbers.errors.minLength',
        { length: issue.length },
        'Billing number must be at least {{length}} characters long.'
      );
    case 'maxLength':
      return translate(
        'pages:providers.billingNumbers.errors.maxLength',
        { length: issue.length },
        'Billing number must be no more than {{length}} characters long.'
      );
    case 'numeric':
      return translate(
        'pages:providers.billingNumbers.errors.numeric',
        'Billing number must contain numbers only.'
      );
    case 'alphanumeric':
      return translate(
        'pages:providers.billingNumbers.errors.alphanumeric',
        'Billing number must contain letters and numbers only.'
      );
  }
};
